import { type AnalyticsEvent } from '@backstage/core-plugin-api';
import { type MetricRequest } from '@internal/plugin-neo4j-analytics-common';

import { BaseAnalyticsEventHandler } from './types';

export class ClickEventHandler extends BaseAnalyticsEventHandler {
  readonly eventName = 'click';
  readonly metricName = 'clicks';

  canHandle(action: string): boolean {
    return action === this.eventName;
  }

  handle(event: AnalyticsEvent): MetricRequest[] {
    if (!this.canHandle(event.action)) {
      return [];
    }

    // Will always be relative for internal links
    const to = event.attributes?.to;
    if (!to || typeof to !== 'string') {
      return [];
    }

    const name = this.getMetricName(this.metricName);
    let hostname: string;
    let linkType: 'internal' | 'external';

    try {
      const url = new URL(to);
      hostname = url.hostname;
      linkType = 'external';
    } catch (error) {
      // Catches on relative (in Backstage's case, internal) paths
      hostname = 'localhost';
      linkType = 'internal';
    }

    return [
      {
        kind: 'counter',
        name: `${name}.links`,
        value: 1,
        attributes: {
          hostname: hostname,
          link_type: linkType,
          to: to,
          extension: event.context.extension,
          plugin: event.context.pluginId,
          link_text: event.subject,
        },
        options: {
          description: 'Total clicks on links',
          unit: '1',
          valueType: 'int',
        },
      },
    ];
  }
}
